import { Point } from '@view-model/models/common/basic';
import type { Size } from '@view-model/models/common/basic';
import { ModelLayout } from '@view-model/models/sticky/layout';

const ColumnCount = 5;

export const layoutFileContainers = (origin: Point, sizes: Size[]): Point[] => {
  const gap = ModelLayout.GridSize;
  let x = origin.x;
  let y = origin.y;
  let rowHeight = 0;

  return sizes.map((size, index) => {
    if (index > 0 && index % ColumnCount === 0) {
      x = origin.x;
      y += rowHeight + gap;
      rowHeight = 0;
    }
    const point = new Point(x, y);
    x += size.width + gap;
    rowHeight = Math.max(rowHeight, size.height);
    return point;
  });
};
